import { ActionButtonVariants } from 'components/action-button';

export const config = {
  buttonVariant: ActionButtonVariants.INVERSE,
  hasBoxShadow: false,
  hasBorder: false,
};
